export default {
	CHANGE_USER(state, payload) {
		state.user = payload;
	},
};
